/* eslint-disable */

import React, { PureComponent } from 'react';
import _ from 'lodash';
import {
  Accordion,
  Icon,
  Button,
  Grid,
  Form,
  Input,
  Dropdown,
  Modal
} from 'semantic-ui-react';
import styled from 'styled-components';

import WrapperAdCheckbox from './WrapperAdCheckbox';

const DimensionText = styled.span`
  color: #2185d0;
  margin-left: 15px;
`;
const FormContainer = styled.div``;
const TextTitle = styled.span`
  color: #121212;
  font-size: 18px;
`;
const TextContent = styled.span`
  color: #121212;
  font-size: 16px;
`;

class PreviewAccordionItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      campaignMonth: props.campaignMonth,
      processing: true,
      showForm: false,
      title: '',
      client: '',
      oem: '',
      product: '',
      selectedTags: {},
      previewId: null,
      confirm: false
    };
  }

  toggleConfirm = (id) => {
    this.setState({ confirm: !this.state.confirm, previewId: id });
  };

  toggleForm = (adPreview) => {
    this.setState({ showForm: !this.state.showForm }, () => {
      if (this.state.showForm) {
        this.setSelectedPreview(adPreview);
      } else {
        this.clearSelectedPreview();
      }
    });
  };

  setSelectedPreview = (adPreview) => {
    const selectedTags = Object.assign(this.state.selectedTags);
    selectedTags['account'] = adPreview.client && parseInt(adPreview.client);
    selectedTags['oem'] = adPreview.oem && parseInt(adPreview.oem);
    selectedTags['product'] =
      adPreview.product && adPreview.product.split(',').map((p) => parseInt(p));

    this.setState({ title: adPreview.title, selectedTags });
  };

  clearSelectedPreview = () => {
    this.setState({ title: '', selectedTags: {}, showForm: false });
  };

  onTagSelect = (e, data) => {
    const tag = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    if (!tag) {
      return;
    }

    const selectedTags = Object.assign(this.state.selectedTags);
    selectedTags[tag.category] = tag.value;

    this.setState({ selectedTags }, () => {
      this.forceUpdate();
    });
  };

  onTagsSelect = (e, data) => {
    const tags = [];

    data.value.map((val) => {
      const tag = _.find(data.options, (option) => {
        return option.value === val;
      });

      if (tag) {
        tags.push(tag);
      }
    });

    const selectedTags = Object.assign(this.state.selectedTags);
    selectedTags[data.id] = data.value;

    this.setState({ selectedTags }, () => {
      this.forceUpdate();
    });
  };

  updatePreview = async (id) => {
    try {
      const { actions } = this.props;
      const payload = {
        id,
        title: this.state.title,
        product: this.state.selectedTags['product'],
        client: this.state.selectedTags['account'],
        oem: this.state.selectedTags['oem'],
        queryType: 'updateAdImport'
      };
      await actions.newAdImport(payload);
      this.props.getAdImports(null);
    } catch (err) {
      console.log(err);
    }
  };

  removePreview = async () => {
    try {
      await this.props.actions.removeAdImport({ id: this.state.previewId });
      this.setState({ confirm: false });
      this.props.getAdImports(null);
      this.props.handleAccordionClick(null);
    } catch (err) {
      console.log(err);
    }
  };

  renderDimensions = (preview) => {
    if (
      preview.html_width &&
      preview.html_width.length > 0 &&
      preview.html_height &&
      preview.html_height.length > 0
    ) {
      return (
        <DimensionText>{`(${preview.html_width} x ${preview.html_height})`}</DimensionText>
      );
    }

    return null;
  };

  renderContent = () => {
    const {
      adPreview,
      activeIndex,
      index,
      renderIframe,
      expandAll,
      editing
    } = this.props;
    const { html_url, html_width, html_height, id } = adPreview;

    return (
      <Accordion.Content active={activeIndex === index || expandAll}>
        <Icon
          name="edit"
          size="large"
          link
          onClick={() => this.toggleForm(adPreview)}
        />
        {editing && this.state.showForm && (
          <FormContainer>
            <Form className="ad-import-preview-form" onSubmit={this.onSubmit}>
              <Form.Group inline>
                <Form.Field inline>
                  <Button
                    color="grey"
                    onClick={() => this.clearSelectedPreview()}
                  >
                    Cancel
                  </Button>
                </Form.Field>
                <Form.Field inline>
                  <Button color="blue" onClick={() => this.updatePreview(id)}>
                    Save
                  </Button>
                </Form.Field>
                <Form.Field inline>
                  <Input
                    placeholder="Title"
                    onChange={(ev) => this.setState({ title: ev.target.value })}
                    value={this.state.title}
                  />
                </Form.Field>
                <Form.Field inline>
                  <Form.Dropdown
                    search
                    selection
                    id={`${index}_account`}
                    value={this.state.selectedTags['account']}
                    options={this.props.optionsTags.account}
                    placeholder="Client"
                    onChange={this.onTagSelect}
                  />
                </Form.Field>
                <Form.Field inline>
                  <Dropdown
                    search
                    selection
                    multiple
                    id="product"
                    value={
                      this.state.selectedTags['product']
                        ? this.state.selectedTags['product']
                        : []
                    }
                    options={this.props.optionsTags.product}
                    placeholder="Product"
                    onChange={this.onTagsSelect}
                  />
                </Form.Field>
                <Form.Field inline>
                  <Dropdown
                    search
                    selection
                    id="oem"
                    value={this.state.selectedTags['oem']}
                    options={this.props.optionsTags.oem}
                    placeholder="OEM"
                    onChange={this.onTagSelect}
                  />
                </Form.Field>
                <Form.Field inline>
                  <Icon
                    link
                    name="trash"
                    color="grey"
                    size="large"
                    onClick={() => this.toggleConfirm(id)}
                  />
                </Form.Field>
              </Form.Group>
            </Form>
          </FormContainer>
        )}

        {renderIframe(html_url, html_width, html_height)}
      </Accordion.Content>
    );
  };

  renderTitles = () => {
    const {
      adPreview,
      activeIndex,
      index,
      handleAccordionClick,
      showCheckboxes,
      selectedAds,
      handleSelectAd,
      expandAll
    } = this.props;
    // console.log(adPreview);
    return (
      <div>
        <Accordion.Title
          active={activeIndex === index || expandAll}
          index={index}
          onClick={() => handleAccordionClick(index)}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                <Icon name="dropdown" />
                <WrapperAdCheckbox
                  adPreview={adPreview}
                  showCheckboxes={showCheckboxes}
                  selectedAds={selectedAds}
                  handleSelectAd={handleSelectAd}
                />
                {adPreview.title}
                {this.renderDimensions(adPreview)}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Title>
        {this.renderContent()}
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.renderTitles()}
        <Modal
          className="modalAdImport"
          size="small"
          closeOnEscape
          closeOnDimmerClick={false}
          open={this.state.confirm}
          onClose={this.toggleConfirm}
        >
          <Modal.Header>
            <TextTitle>Display Ad Preview</TextTitle>
          </Modal.Header>
          <Modal.Content>
            <TextContent>Are you sure to delete this Preview?</TextContent>
          </Modal.Content>
          <Modal.Actions>
            <Button color="grey" onClick={() => this.toggleConfirm()}>
              Cancel
            </Button>
            <Button color="red" onClick={() => this.removePreview()}>
              Delete
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default PreviewAccordionItem;



// WEBPACK FOOTER //
// ./src/screens/AdImport/AdImportComponents/PreviewAccordionItem.js